import AcceptTabSnippet from './AcceptTabSnippet.view';
export default AcceptTabSnippet;
